export default function () {
  const invisibility_class = 'opacity-0 invisible';

  $('.open-popup').each(function () {
    $(this).on('click', function () {
      $(this).next().removeClass(invisibility_class);
    });
  });

  $('.close-popup').each(function () {
    $(this).on('click', function () {
      $(this).parent().parent().addClass(invisibility_class);
    });
  });

  $('.contact-popup').on('click', function ({ target }) {
    if (target === this) {
      $(this).addClass(invisibility_class);
    }
  });

  $('.wpcf7-form-control, .form-control').on('focus', function () {
    $(this).parent().next().addClass('active');
  });

  $('.wpcf7-form-control, .form-control').on('focusout', function () {
    if (!$(this).val()) $(this).parent().next().removeClass('active');
  });

  $('input.wpcf7-file').on('change', function (event) {
    var name = event.target.files[0].name;
    $(this).parent().prev().text(name);
  });

  $('.contact-popup').each(function () {
    const inputCar = $(this).find('.input-car-name');
    if (inputCar) inputCar.val($(this).data('car'));

    const inputCarID = $(this).find('.input-car-id');
    if (inputCarID) inputCarID.val($(this).data('car-id'));

    const inputUser = $(this).find('.input-user-id');
    if (inputUser) inputUser.val($(this).data('user'));

    const inputReg = $(this).find('.input-car-registration');
    if (inputReg) inputReg.val($(this).data('registration'));

    const inputPrice = $(this).find('.input-car-calprice');
    if (inputPrice) inputPrice.val($(document).find('#total-price').html());
  });

  const singleCarForm = $('.single-car .wpcf7');
  singleCarForm.find('.input-car-name').val(singleCarForm.parent().data('car'));
}
